module.exports = __webpack_public_path__ + "img/rejected-status.7d5166d3.svg";